<section class="edit-templates-overview" [style.width.px]="menuWidth">
  <div class="header">
    <div class="text">
      <p class="title" translate>Templates</p>
      <p class="caption" translate>Template library for disturbance information</p>
    </div>

    <div class="buttons">
      <button type="button" (click)="onClickNewTemplate()" translate>Ny Mall</button>
    </div>
  </div>

  @if ({
    automaticTemplates: automaticTemplates$ | async,
    templates: templates$ | async,
    selectedTemplate: selectedTemplate$ | async
    }; as observables) {
    <div class="templates-list">
      <input type="checkbox"
        id="automatic-templates-wrapper"
        [formControl]="automaticTemplateWrapper"
        (keydown.space)="onClickAutomaticTemplateWrapper()"
        (keydown.enter)="onClickAutomaticTemplateWrapper()"
        (keydown.arrowUp)="onAutomaticWrapperMarkPrevious($event)"
        (keydown.arrowDown)="onAutomaticWrapperMarkNext($event)"
        #automaticTemplatesWrapper>
        <div class="automatic-templates-wrapper" (click)="onClickAutomaticTemplateWrapper()">
          <div class="content">
            <div class="name">
              <i class="fa-solid"
                        [ngClass]="automaticTemplateWrapper.value 
                            ? 'fa-folder-open' 
                            : 'fa-folder'"></i>
              <p translate>Templates for automatic disturbance information</p>
            </div>
            <i class="fa-solid"
                    [ngClass]="automaticTemplateWrapper.value 
                        ? 'fa-chevron-up' 
                        : 'fa-chevron-down'">
            </i>
          </div>
        </div>
        @if (automaticTemplateWrapper.value) {
          @for (template of observables.automaticTemplates; track template.id) {
            <input type="checkbox"
              [id]="template.id"
              [checked]="observables.selectedTemplate?.id === template.id"
              (focus)="onFocusTemplate(template)"
              (keydown.arrowUp)="onAutomaticMarkPrevious($event)"
              (keydown.arrowDown)="onAutomaticMarkNext($event)"
              (keydown.space)="$event.preventDefault()"
              #templateCheckbox/>
              <div class="template"
                (click)="selectTemplate(template)">
                <div class="content automatic">
                  <div class="name">
                    <i class="fa-solid fa-file-lines"></i>
                    <p>{{ template.name }}</p>
                  </div>
                </div>
              </div>
            }
          }
          @for (template of observables.templates; track template.id) {
            <input type="checkbox"
              [id]="template.id"
              [checked]="observables.selectedTemplate?.id === template.id"
              (focus)="onFocusTemplate(template)"
              (keydown.arrowUp)="markPrevious($event)"
              (keydown.arrowDown)="markNext($event)"
              (keydown.space)="$event.preventDefault()"
              #templateCheckbox/>
              <div class="template"
                (click)="selectTemplate(template)">
                <div class="content">
                  <div class="name">
                    <i class="fa-solid fa-file-lines"></i>
                    <p>{{ template.name }}</p>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </section>

      <section class="edit-templates-content">
        <app-edit-templates [selectedTemplate$]="selectedTemplate$"></app-edit-templates>
      </section>